import React, { useState } from "react";
import { Send } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { leadsApi } from "../../api";
import { toast } from "sonner";

export default function SubmitDeal() {
  const { c } = useLang();
  const s = c.submitDeal;
  const [f, setF] = useState({ name: "", email: "", phone: "", address: "", price: "", notes: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    if (!f.name || !f.email || !f.address) { toast.error(s.required); return; }
    setBusy(true);
    try {
      await leadsApi.submitDeal(f);
      toast.success(s.success);
      setF({ name: "", email: "", phone: "", address: "", price: "", notes: "" });
    } catch { toast.error(s.error); }
    finally { setBusy(false); }
  };

  return (
    <section id="submit-deal" className="section" style={{ background: "#0c0c0f" }}>
      <div className="container-x" style={{ maxWidth: 820 }}>
        <div className="reveal" style={{ marginBottom: "2.2rem" }}>
          <span className="eyebrow">{s.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2rem,4.5vw,3.4rem)", margin: "1.2rem 0" }}>
            {s.title.pre}<span className="italic-gold">{s.title.em}</span>{s.title.post}
          </h2>
          <p className="body-text">{s.para}</p>
        </div>

        <div className="card reveal" style={{ padding: "2.5rem", background: "linear-gradient(180deg, rgba(201,162,75,0.04), transparent)" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
            <input className="field" data-testid="submit-deal-name" placeholder={s.name + " *"} value={f.name} onChange={(e) => set("name", e.target.value)} />
            <input className="field" data-testid="submit-deal-email" placeholder={s.email + " *"} value={f.email} onChange={(e) => set("email", e.target.value)} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
            <input className="field" data-testid="submit-deal-phone" placeholder={s.phone} value={f.phone} onChange={(e) => set("phone", e.target.value)} />
            <input className="field" data-testid="submit-deal-price" placeholder={s.price} value={f.price} onChange={(e) => set("price", e.target.value)} />
          </div>
          <input className="field" data-testid="submit-deal-address" style={{ marginBottom: "1rem" }} placeholder={s.address + " *"} value={f.address} onChange={(e) => set("address", e.target.value)} />
          <textarea className="field" data-testid="submit-deal-notes" rows={4} style={{ marginBottom: "1.4rem", resize: "vertical" }} placeholder={s.notes} value={f.notes} onChange={(e) => set("notes", e.target.value)} />
          <button className="btn-gold" data-testid="submit-deal-btn" onClick={submit} disabled={busy} style={{ width: "100%" }}>
            <Send size={15} /> {busy ? "…" : s.submit}
          </button>
        </div>
      </div>
    </section>
  );
}
